import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TicketDetail } from '../../shared/models/ticket-model/tiket.model';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-detail-info-ticket',
  imports: [CommonModule, MatIconModule, GoogleMapsModule, MatTooltipModule],
  templateUrl: './detail-info-ticket.html',
  styleUrl: './detail-info-ticket.css',
})
export class DetailInfoTicket {
  @Input() ticketDetail: TicketDetail | null = null;
  @Input() center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  public expansion = false;
  public dataTicket: { id: number; nameData: string; value: string }[] = [];
  public zoom = 9;

  ngOnInit(): void {
    this.dataTicket = [
      { id: 1, nameData: 'Puntos de conexión', value: this.ticketDetail?.Location?.Address ?? '' },
      { id: 2, nameData: 'Nombre de cliente', value: this.ticketDetail?.Customer ?? '' },
      { id: 3, nameData: 'Tipo de conexión', value: this.ticketDetail?.Priority ?? '' },
      { id: 4, nameData: 'Región', value: this.ticketDetail?.Region ?? '' },
      { id: 5, nameData: 'Zona', value: this.ticketDetail?.Zone ?? '' },
      { id: 6, nameData: 'Sitio', value: this.ticketDetail?.Site ?? '' },
      { id: 7, nameData: 'Flujo de trabajo', value: this.ticketDetail?.WorkFlow ?? '' },
      { id: 8, nameData: 'Fecha de creación', value: this.ticketDetail?.StartDate ?? '' },
    ];
  }
}
